import { InputTimeComponent } from './input-time.component';

export default angular
  .module('sfMobile.components.input-time', ['sfMobile.services.platform'])
  .component('sfInputTime', InputTimeComponent).name;
